import React from "react";
import "../../../../../css/CashflowModeller2/Buttons/Tooltip.css";

/**
 * TooltipBox component renders its children inside a styled tooltip container.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {React.ReactNode} props.children - The content to display inside the tooltip.
 * @returns {JSX.Element} The rendered tooltip box component.
 */
const TooltipBoxRight = ({ children }) => {
  return (
    <div className="tooltip-box-right">
      <div className="Label">{children}</div>
    </div>
  );
};

export default TooltipBoxRight;
